import { StripHtml } from "@utils/helpers";
import BaseActions from "features/library/actions/library-item-actions/BaseActions";
import EditCustomLibrary from "features/library/modals/EditCustomLibrary";
import { BasicActionsDropdown } from "shared/dropdowns/BasicActionsDropdown";
import { FlexAlignCenter, FlexColumn } from "shared/ui-basics/index";
import styled from "styled-components/macro";
import { useModal } from "use-modal-hook";
import { ColorCircle } from "./ColorCircle";
import { Library, LibraryValue } from "features/library/types";


interface CustomLibraryListItemProps {
    library: Library;
    item: LibraryValue;
    filteredItems: LibraryValue[]
}

export const CustomLibraryListItem: React.FC<CustomLibraryListItemProps> = ({filteredItems, library, item }) => {
    const [showEditModal] = useModal(EditCustomLibrary);

    const handleClick = () => {
        showEditModal({
            libraryId: library?.id,
            itemId: item?.id,
            customItemsIds: filteredItems?.map((v) => v?.id),
        });
    };

    return (
        <Container onClick={handleClick}>
            <FlexAlignCenter gap="16">
                <ColorCircle color={item?.colorCode} />
                <FlexColumn gap="4">
                    <Name>{item?.name}</Name>
                    {item?.description && <Description className='ellipsis'>{StripHtml(item?.description)}</Description>}
                </FlexColumn>
            </FlexAlignCenter>
            <ActionsContainer>
                <BasicActionsDropdown actions={BaseActions({ libraryId: library?.id, item })} stopPropagation={true} />
            </ActionsContainer>
        </Container>
    );
};

const ActionsContainer = styled.div`
	visibility: hidden;
`;
const Container = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	height: 84px;
	padding: 8px 16px;
	border-radius: 4px;
	border: 1px solid #d9d9d9;
	:hover {
		border: 1px solid #333;
		cursor: pointer;
	}
	:hover ${ActionsContainer} {
		visibility: visible;
	}
`;

const Name = styled.div`
	color: #262626;
	font-family: "Inter";
	font-size: 14px;
	font-style: normal;
	font-weight: 600;
	line-height: 150%;
    display: -webkit-box; 
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1; 
    text-overflow: ellipsis;
    white-space: normal;
`;

const Description = styled.div`
    overflow: hidden;
    color: #262626;
    display: -webkit-box; 
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; 
    text-overflow: ellipsis;
    white-space: normal;
    font-family: "Inter";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
`;